import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import Button from '../common/Button.react';
import AddImage from '../common/assets/add-image/AddImage.button';
import ReCrop from '../common/assets/add-image/ReCrop.button';
import Input from '../common/form/Input.react';
var SlideText = function SlideText(_ref) {
  var slideID = _ref._id,
    line1 = _ref.line1,
    line2 = _ref.line2,
    line3 = _ref.line3,
    line4 = _ref.line4,
    _onChange = _ref.onChange;
  var dispatch = useDispatch();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    style: {
      marginTop: 20
    }
  }, "Text"), /*#__PURE__*/React.createElement("div", {
    className: "slide__text"
  }, /*#__PURE__*/React.createElement(Input, {
    placeholder: "Line1",
    value: line1,
    onChange: function onChange(e) {
      _onChange('line1', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Input, {
    placeholder: "Line2",
    value: line2,
    onChange: function onChange(e) {
      _onChange('line2', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Input, {
    placeholder: "Line3",
    value: line3,
    onChange: function onChange(e) {
      _onChange('line3', e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Input, {
    placeholder: "Line4",
    value: line4,
    onChange: function onChange(e) {
      _onChange('line4', e.target.value);
    }
  })));
};
export default SlideText;